import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokhandalataxifare() {



  const cardData =
  {
    keyword: 'Mumbai to Khandala Taxi Fare ',
    heading: 'Shambhu Cabs: Mumbai to Khandala Taxi Fare  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Khandala Taxi services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and weekend tourists heading to the scenic getaway of Khandala. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Khandala with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking assistance, Shambhu Cabs makes your travel stress-free and convenient. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Khandala taxi services for travelers seeking comfort, safety, affordability, and a reliable travel experience.',

    top: 'Top Places to Visit in Khandala with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Rajmachi Point",
    "description": "Rajmachi Point is one of Khandala’s most iconic viewpoints, offering sweeping views of the lush Rajmachi Fort and the surrounding valleys. The spot is known for its dramatic cliffs, cool breezes, and mist-covered landscapes during monsoon. Visitors often stop here for photography, relaxation, and appreciating the natural beauty of the Sahyadris. The point is especially popular during early mornings when the mountains glow with sunlight."
  },
  {
    "title": "Duke’s Nose",
    "description": "Duke’s Nose, also known as Nagphani, is a prominent cliff shaped like a snake’s hood. It is a paradise for thrill-seekers and adventure lovers, offering rock climbing, rappelling, and trekking opportunities. The viewpoint provides breathtaking panoramas of the Western Ghats, green valleys, and deep gorges. Its rugged terrain and dramatic drop-offs make it one of Khandala’s most photographed natural landmarks."
  },
  {
    "title": "Kune Waterfall",
    "description": "Kune Waterfall is a three-tiered cascade plunging from a height of nearly 200 meters, making it one of Maharashtra’s tallest waterfalls. Surrounded by dense forests and emerald hills, the waterfall is particularly enchanting during monsoon. Visitors come here to enjoy the cool spray, nature photography, and peaceful atmosphere. The lush greenery and roaring water create a mesmerizing natural setting."
  },
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap is a dramatic cliff point that resembles a tiger jumping off the edge, from which it gets its name. The viewpoint offers spellbinding views of the valley below and the surrounding hills. Visitors often enjoy the echo point here, along with paragliding activities during the season. The cool winds, misty weather, and scenic charm make Tiger’s Leap a must-visit spot in Khandala."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a popular leisure destination known for its cascading steps and cheerful crowds during the monsoon season. When the water overflows, the steps turn into natural waterfalls, allowing visitors to enjoy the refreshing flow. Surrounded by wooded hills, this spot is perfect for picnics, relaxation, and soaking in the playful monsoon atmosphere. Hot corn, tea stalls, and local snacks add to the charm."
  },
  {
    "title": "Amrutanjan Point",
    "description": "Amrutanjan Point marks the entrance to Khandala and offers panoramic views of the Duke’s Nose cliff and the lush green surroundings. The viewpoint is quieter compared to other tourist spots, making it ideal for peaceful nature walks, photography, and enjoying the mountain breeze. On clear days, visitors can enjoy distant valley views and watch clouds drifting over the hills."
  },
  {
    "title": "Khandala Ghat Viewpoint",
    "description": "The Khandala Ghat Viewpoint allows travelers to admire the scenic beauty of the winding Mumbai-Pune Expressway and the surrounding forested hills. The point is especially stunning during monsoon when waterfalls gush down the hills and mist envelops the ghat roads. It’s a popular stop for travelers looking to capture the dramatic beauty of the Western Ghats."
  },
  {
    "title": "Shivaji Park (Khandala)",
    "description": "Shivaji Park in Khandala is a peaceful garden and recreational space ideal for families and nature lovers. It features walking trails, shaded seating areas, and well-maintained greenery. Visitors come here to relax, enjoy picnics, and breathe in the crisp hill-station air. The park offers a calm break from Khandala’s busy viewpoints."
  },
  {
    "title": "Lonavala Lake",
    "description": "Located close to Khandala, Lonavala Lake is a serene waterbody surrounded by hills and lush greenery. The lake is at its best during monsoon when it fills up completely and the surroundings turn lush. Visitors can enjoy long walks, photography, quiet lakeside moments, and watching migratory birds. The peaceful atmosphere makes it a refreshing escape from city life."
  },
  {
    "title": "Valvan Dam",
    "description": "Valvan Dam is a beautiful picnic spot near Khandala, offering a calm lakeside setting with scenic views of gardens, forests, and the Sahyadri hills. Built across the Kundali River, it also features a landscaped garden at its base, perfect for evening strolls. The dam is a popular spot for nature lovers, families, and photographers, especially during early mornings and sunsets."
  }
],

"services": [
  {
    "name": "Mumbai Khandala Taxi",
    "description": "Mumbai Khandala Taxi provides comfortable, reliable, and safe outstation travel for passengers heading from Mumbai to the scenic hill station of Khandala. This service includes well-maintained cars, professionally trained drivers, and flexible pickup options across all areas of Mumbai. Ideal for leisure trips, weekend getaways, family travel, and corporate journeys, the service ensures a smooth and enjoyable ride through the Mumbai–Pune Expressway. With transparent pricing, timely service, and customer-first support, it remains one of the most preferred travel options."
  },
  {
    "name": "One-Way Cab Mumbai Khandala",
    "description": "One-Way Cab Mumbai Khandala is perfect for travelers looking for a single-drop service without a return fare. This economical option includes clean vehicles, trained chauffeurs, and convenient doorstep pickup. Designed for tourists, families, and business travelers, the service provides a seamless road journey to Khandala with efficient routing and safety-focused driving. Ideal for hotel check-ins, resort stays, personal trips, or quick intercity transfers."
  },
  {
    "name": "Khandala Trip Cab Mumbai",
    "description": "Khandala Trip Cab Mumbai offers dedicated sightseeing and travel solutions for those visiting the popular hill station. Specially curated for nature lovers, adventure travelers, and weekend vacationers, this cab service includes point-to-point transfers, round trips, and flexible tour itineraries. Passengers can choose from sedans, SUVs, or premium cars based on group size and comfort preference. Experienced drivers familiar with the ghat routes ensure a pleasant and scenic travel experience."
  },
  {
    "name": "Affordable Taxi Mumbai Khandala",
    "description": "Affordable Taxi Mumbai Khandala offers budget-friendly outstation cab options without compromising safety or comfort. Ideal for small families, college groups, and solo travelers, this service provides economical ride packages, transparent pricing, and smooth navigation along the expressway. Clean cars, cooperative drivers, and on-time pickup ensure a stress-free travel experience at a pocket-friendly cost."
  },
  {
    "name": "Best Cab Mumbai Khandala",
    "description": "Best Cab Mumbai Khandala delivers high-quality service with top-rated vehicles, punctual drivers, and a focus on passenger comfort. Designed for premium and regular travelers alike, the service promises a superior travel experience with comfortable seating, climate control, and seamless expressway travel. Whether it’s a quick getaway or a planned family vacation, this service ensures dependable and luxurious transportation."
  },
  {
    "name": "SUV Cab Mumbai Khandala",
    "description": "SUV Cab Mumbai Khandala offers spacious and powerful SUVs perfect for hilly terrain and long-distance comfort. Families, large groups, and travelers carrying extra luggage prefer this service for its roomy interiors, smooth performance, and excellent safety features. With experienced drivers familiar with expressway and ghat sections, passengers enjoy a stable and comfortable ride."
  },
  {
    "name": "Sedan Cab Mumbai Khandala",
    "description": "Sedan Cab Mumbai Khandala is ideal for passengers seeking comfortable and fuel-efficient travel. Suitable for couples, solo travelers, and business executives, sedans offer smooth rides, comfortable seating, and affordable pricing. Professional drivers ensure a safe and pleasant journey from Mumbai to Khandala."
  },
  {
    "name": "Mumbai Khandala Fare Estimate",
    "description": "Mumbai Khandala Fare Estimate gives passengers a clear idea of taxi costs before booking their trip. It covers charges for sedans, SUVs, one-way rides, round trips, peak hours, tolls, and optional add-on services. This helps travelers plan their journey financially with complete transparency and no hidden fees."
  },
  {
    "name": "Cheap Mumbai Khandala Taxi Fare",
    "description": "Cheap Mumbai Khandala Taxi Fare focuses on offering the lowest possible travel rates without compromising on safety or service quality. Ideal for budget travelers, this option includes clean cars, reliable drivers, and cost-friendly travel plans for quick weekend trips or short vacations."
  },
  {
    "name": "24×7 Mumbai Khandala Cab",
    "description": "24×7 Mumbai Khandala Cab ensures round-the-clock availability for travelers needing early morning, late night, or urgent bookings. With fast dispatch, professional chauffeurs, and safe vehicles, this service guarantees reliable transport at any hour, perfect for spontaneous trips or time-sensitive travel."
  },
  {
    "name": "Fast Cab Mumbai Khandala",
    "description": "Fast Cab Mumbai Khandala is designed for travelers who prefer quicker journeys via the expressway. Professional drivers use the fastest routes while maintaining safety, making this service ideal for business meetings, urgent travel, or quick weekend getaways."
  },
  {
    "name": "Corporate Cab Mumbai Khandala",
    "description": "Corporate Cab Mumbai Khandala offers premium chauffeur-driven taxis for business travelers. With punctual service, high-quality vehicles, and professional drivers, it is ideal for corporate events, business meetings, client travel, and company-sponsored trips between Mumbai and Khandala."
  },
  {
    "name": "Premium Cab Khandala Trip",
    "description": "Premium Cab Khandala Trip provides luxury travel options with high-end sedans and premium SUVs. Designed for travelers seeking comfort, style, and a superior experience, these cabs include plush interiors, experienced chauffeurs, and seamless expressway driving for a luxurious journey."
  },
  {
    "name": "Express Highway Cab",
    "description": "Express Highway Cab is optimized for fast, smooth, and efficient travel along the Mumbai–Pune Expressway. Ideal for those wanting to minimize travel time, this service includes experienced drivers trained for highway routes, ensuring both speed and safety during the trip."
  },
  {
    "name": "Mumbai Khandala Pickup Drop",
    "description": "Mumbai Khandala Pickup Drop offers point-to-point service from homes, hotels, airports, and offices in Mumbai to any location in Khandala. With flexible scheduling and professional drivers, this service ensures maximum convenience and timely travel."
  },
  {
    "name": "Safe Taxi Mumbai Khandala",
    "description": "Safe Taxi Mumbai Khandala prioritizes passenger safety with verified drivers, GPS-enabled vehicles, and strict hygiene standards. Perfect for families, women travelers, and seniors, this service ensures a secure and stress-free journey to Khandala."
  },
  {
    "name": "Family Cab Mumbai Khandala",
    "description": "Family Cab Mumbai Khandala is designed for group travel, offering spacious cars, child-friendly seating, and comfortable interiors. Ideal for family outings, weekend vacations, and special trips, this service ensures a relaxing travel experience with courteous drivers and smooth travel routes."
  }
],

"tableData": [
  ["Mumbai Khandala Taxi", "One-Way Cab Mumbai Khandala"],
  ["Khandala Trip Cab Mumbai", "Affordable Taxi Mumbai Khandala"],
  ["Best Cab Mumbai Khandala", "SUV Cab Mumbai Khandala"],
  ["Sedan Cab Mumbai Khandala", "Mumbai Khandala Fare Estimate"],
  ["Cheap Mumbai Khandala Taxi Fare", "24×7 Mumbai Khandala Cab"],
  ["Fast Cab Mumbai Khandala", "Corporate Cab Mumbai Khandala"],
  ["Premium Cab Khandala Trip", "Express Highway Cab"],
  ["Mumbai Khandala Pickup Drop", "Safe Taxi Mumbai Khandala"],
  ["Family Cab Mumbai Khandala", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Khandala Taxi Fare with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers affordable and reliable Mumbai to Khandala taxi services, ideal for quick getaways, hill station trips, and smooth intercity travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in comfortable, air-conditioned, and regularly maintained cabs to enjoy a relaxing journey to Khandala."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Expressway and Ghat Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Khandala route, ensuring safe, smooth, and timely travel through expressway and ghat sections."
  },
  {
    "WhyChooseheading": "Transparent Mumbai to Khandala Taxi Fare",
    "WhyChoosedescription": "We provide clear and upfront taxi fare details with no hidden charges—fuel, tolls, and driver allowances included for your convenience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, fare information, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Hill Station Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental packages designed to suit your Mumbai to Khandala travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every cab is thoroughly cleaned and sanitized before each journey to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We offer punctual pickups and smooth service, ensuring your Mumbai to Khandala trip is comfortable and stress-free."
  }
]

























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Khandala taxi services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Khandala taxi services with experienced and professional drivers.',
  },
  {
    question: 'How can I check the Mumbai to Khandala taxi fare with Shambhu Cabs?',
    answer: 'You can check the fare on our website, mobile app, or by contacting our 24x7 customer support team for detailed pricing.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Khandala taxi bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and premium cars suitable for a smooth and comfortable trip to Khandala.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Khandala route?',
    answer: 'Yes, our drivers are licensed, professional, and well-versed with the Mumbai to Khandala route to ensure a safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Khandala taxi?',
    answer: 'Absolutely. You can select any pickup point in Mumbai and choose a drop-off location anywhere in Khandala.',
  },
  {
    question: 'Is the Mumbai to Khandala taxi service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Khandala taxi booking services to suit your travel timing.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Khandala taxi bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols for passenger safety.',
  },
  {
    question: 'What payment options are available for Mumbai to Khandala taxi fare?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Khandala journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Khandala travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rakesh More',
    feedback: 'Shambhu Cabs offered a reasonable Mumbai to Khandala taxi fare, and the journey was extremely comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Jadhav',
    feedback: 'Excellent service! The taxi fare from Mumbai to Khandala was affordable and the ride was smooth and safe.',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khandala Taxi Fare",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-khandala-cab.jpg",
  "description": "Shambhu Cabs provides reliable Mumbai to Khandala taxi services with fare estimates for one-way and round trips. Book sedans, SUVs, or premium cars for family trips, corporate travel, or hill station visits. Enjoy affordable, safe, and fast taxi service available 24×7 with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-khandala-taxi-fare"
  }
};







  return (
    <div>
      <Helmet>
  <title>Mumbai to Khandala Taxi Fare | Hill Station & Outstation Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Khandala taxi with Shambhu Cabs. Affordable, safe, and comfortable service with fare estimates for one-way or round trips. Available 24×7 with sedan, SUV, and premium cars for family trips, corporate travel, and hill station visits."
  />

  <meta
    name="keywords"
    content="Mumbai Khandala Taxi, One-Way Cab Mumbai Khandala, Khandala Trip Cab Mumbai, Affordable Taxi Mumbai Khandala, Best Cab Mumbai Khandala, SUV Cab Mumbai Khandala, Sedan Cab Mumbai Khandala, Mumbai Khandala Fare Estimate, Cheap Mumbai Khandala Taxi Fare, 24×7 Mumbai Khandala Cab, Fast Cab Mumbai Khandala, Corporate Cab Mumbai Khandala, Premium Cab Khandala Trip, Express Highway Cab, Mumbai Khandala Pickup Drop, Safe Taxi Mumbai Khandala, Family Cab Mumbai Khandala"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokhandalataxifare;